import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik, Field } from "formik";
import { useHistory } from "react-router-dom";
import { Tooltip } from "reactstrap";
import information from "web/assets/images/informationIcon.png";
import TimePickerInput from "web/components/form-elements/TimePickerInput";
import YesNoModal from "web/components/YesNoModal";
import Button from "web/components/Button";
import AlertModal from "web/components/AlertModal";
import RadioButton from "web/components/form-elements/RadioButton";
import { getInitialValues, VALIDATION_SCHEMA, } from "web/components/utils/InternalPreferencesUtils";
import { fetchManageAccountDataApi } from "redux/actions/profile";
import { manageAccCompanyPrefUpdate } from "../../../../../redux/actions/postLoad";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PaymentDetail from "./PaymentDetail/index";
import Profile from "./Profile/index";
import OfficeHours from "./OfficeHours/index";
import Layout from "web/components/Layout";
import { notificationPreferences, updateUserStatesList } from "redux/actions/notification";
import styled from "styled-components";
import styles from "./internalPrefer.module.scss";
import { fetchLanguageContentNew } from "redux/actions/language";
import { stateLabelValues, stateConvert } from 'web/components/utils/updatedStatesListAbbreviation';
import UserTaxExemptionForm from "./TaxExemption";

const ManageAccount = (props) => {
  const [response, setResponse] = useState(undefined);
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem("token");
  const scrollToProfileSection = useRef(null);
  const userType = localStorage.getItem("userType");
  const accountType = localStorage.getItem("accountType");
  const [manageAccountPageData, setManageAccountPageData] = useState()

  // removing duplicate
  const stateListTemp = stateLabelValues.filter((val, index, self) =>
    index === self.findIndex((t) => (
      t.value === val.value
    ))
  )

  const [statesList, setStatesList] = useState(stateListTemp)
  const [filteredStatesList, setFilteredStatesList] = useState(stateListTemp)
  const [displayStatesList, setDisplayStatesList] = useState(false)
  const [userPreferredStates, setUserPreferredStates] = useState([])
  const [userPreferredStatesTemp, setUserPreferredStatesTemp] = useState([])
  const [stateSearch, setStateSearch] = useState('')
  const [stateAllChecked, setStateAllChecked] = useState(false)
  const [updateButtonDisableState, setUpdateButtonDisableState] = useState(false)

  let selectedSearch;
  if (accountType === "Seller") {
    selectedSearch = "PostLoad";
  }
  if (accountType === "Buyer") {
    selectedSearch = "PostInventory";
  }
  const [milesValue, setMilesValue] = useState("");
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  let title = "";

  const [yesNomodal, setYesNoModal] = useState(false);
  const yesNoToggleModal = () => setYesNoModal(!yesNomodal);
  let toggleNotification = [
    "checkedAll",
    "ORDER",
    "BID_LOAD_RECEIVED",
    "BUY_NOW",
    "OFFER_LOAD_RECEIVED",
    "OFFER_INVENTORY_RECEIVED",
    "INVENTORY",
    "LOAD",
    "NETWORK",
  ];
  const [state, setState] = React.useState({
    checkedAll: true,
    ORDER: true,
    BID_LOAD_RECEIVED: true,
    BUY_NOW: true,
    OFFER_LOAD_RECEIVED: true,
    OFFER_INVENTORY_RECEIVED: true,
    INVENTORY: true,
    LOAD: true,
    NETWORK: true,
  });
  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  const [dropLiveState, setDropLiveState] = useState([
    {
      value: "LIVE",
      label: 'Live Unload',
    },
    {
      value: "DROP",
      label: 'Drop Trailer',
    },
  ]);

  const notesArr = [
    {
      value: "FLAT_BED",
      label: pageLanguageContents?.Arrow_Preference[3]?.Equipment_OP1,
    },
    {
      value: "VAN",
      label: pageLanguageContents?.Arrow_Preference[4]?.Equipment_OP2,
    },
    {
      value: "NO_PREFERENCES",
      label: pageLanguageContents?.Arrow_Preference[5]?.Equipment_OP3,
    },
  ];

  useEffect(() => {
    let redirectionTypeVal = localStorage.getItem('redirectionType')
    if (redirectionTypeVal === 'toProfileSection' && scrollToProfileSection.current) {
      localStorage.removeItem('redirectionType')
      scrollToProfileSection.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    if (token === null) {
      history.push('/sign-in')
    }
  }, [])

  useEffect(() => {
    if (languageContentNew?.H8_Nav_Preference_Page) setPageLanguageContents(languageContentNew.H8_Nav_Preference_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  useEffect(() => {
    fetchManageAccountPageData()
  }, [])

  const fetchManageAccountPageData = async () => {
    let response
    let data = {
      authId: localStorage.getItem('authId')
    }
    response = await dispatch(fetchManageAccountDataApi(data, token));
    if (response.status === 200) {
      setManageAccountPageData(response.data)
      setEmailPrefFunction(response.data?.notificationPreferences)
      fetchUserStatesList(response.data)
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        setModalContent(response.data?.error?.message || 'Something went wrong, please try again in sometime.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const setEmailPrefFunction = notPref => {
    if (notPref) {
      setState({
        checkedAll: (notPref.length === 8 || notPref.length === 10) ? true : false,
        ORDER: notPref.find((value) => value === "ORDER") ? true : false,
        BID_LOAD_RECEIVED: notPref.find((value) => value === "BID_LOAD_RECEIVED") ? true : false,
        BUY_NOW: notPref.find((value) => value === "BUY_NOW") ? true : false,
        OFFER_LOAD_RECEIVED: notPref.find((value) => value === "OFFER_LOAD_RECEIVED") ? true : false,
        OFFER_INVENTORY_RECEIVED: notPref.find((value) => value === "OFFER_INVENTORY_RECEIVED") ? true : false,
        INVENTORY: notPref.find((value) => value === "INVENTORY") ? true : false,
        LOAD: notPref.find((value) => value === "LOAD") ? true : false,
        NETWORK: notPref.find((value) => value === "NETWORK") ? true : false,
      });
    }
  }

  const fetchUserStatesList = async (manageAccData) => {
    if (manageAccData) {
      updatedStatesListFunc(manageAccData)
      if (manageAccData?.newslettersStates) {
        setUserPreferredStates(manageAccData?.newslettersStates)
        if (manageAccData?.newslettersStates?.length === 47) setStateAllChecked(true)
      }
    }
  }

  const updatedStatesListFunc = (manageAccData) => {
    let filteredList = JSON.parse(JSON.stringify(statesList))
    if (manageAccData) {
      let userBaseState = manageAccData?.userDetails?.address?.state
      let selectedStatesListTemp = manageAccData.newslettersStates ? manageAccData.newslettersStates : []
      filteredList = filteredList.map((val, index) => {
        return {
          ...val,
          checked: selectedStatesListTemp.includes(val.label) ? true : false,
          order: index + 1
        }
      })
      if (userBaseState) filteredList = filteredList.filter(val => val.label !== userBaseState)
    }
    setStatesList(filteredList)
    setFilteredStatesList(filteredList)
  }

  const filterStatesListFunc = (filterText, currentStateUpdates) => {
    setStateSearch(filterText)
    let tempStatesList = []
    if (currentStateUpdates) tempStatesList = currentStateUpdates
    else tempStatesList = JSON.parse(JSON.stringify(statesList))
    let filteredList = tempStatesList.filter(val => (val.label?.toString().toLowerCase().includes(filterText?.toLowerCase())
      || val.value?.toString().toLowerCase().includes(filterText?.toLowerCase())))
    setFilteredStatesList(filteredList)
  }

  const deleteNewsletterState = (state) => {
    let tempuserPreferredStates = JSON.parse(JSON.stringify(userPreferredStates))
    tempuserPreferredStates = tempuserPreferredStates.filter(item => item !== state)
    setUserPreferredStates(tempuserPreferredStates)

    let tempStatesList = JSON.parse(JSON.stringify(statesList))
    tempStatesList = tempStatesList.map(val => {
      return {
        ...val,
        checked: state === val.label ? false : val.checked
      }
    })
    setStatesList(tempStatesList)
    filterStatesListFunc(stateSearch, tempStatesList)
    setStateAllChecked(false)
  }

  const onCheckStateBox = (state, checked) => {
    let tempuserPreferredStates = JSON.parse(JSON.stringify(userPreferredStates))
    if (checked && !tempuserPreferredStates.includes(state)) {
      let statesLabelList = statesList.map(val => val.label)
      if (state === 'ALL') tempuserPreferredStates = statesLabelList
      else {
        tempuserPreferredStates.push(state)
        if (tempuserPreferredStates.length === 47) setStateAllChecked(true)
      }
      tempuserPreferredStates = tempuserPreferredStates.sort((a, b) => {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      })
    } else {
      if (state === 'ALL') tempuserPreferredStates = []
      else {
        tempuserPreferredStates = tempuserPreferredStates.filter(item => item !== state)
        setStateAllChecked(false)
      }
    }
    setUserPreferredStates(tempuserPreferredStates)

    let tempStatesList = JSON.parse(JSON.stringify(statesList))
    if (state === 'ALL') {
      tempStatesList = tempStatesList.map(val => {
        return {
          ...val,
          checked: checked
        }
      })
    } else {
      tempStatesList = tempStatesList.map(val => {
        if (val.label === state) {
          return {
            ...val,
            checked: checked
          }
        } else return val
      })
    }
    setStatesList(tempStatesList)
    filterStatesListFunc(stateSearch, tempStatesList)
  }

  const cancelStatesListDropDown = () => {
    setDisplayStatesList(false)
    setUserPreferredStates(userPreferredStatesTemp)

    let tempStatesList = JSON.parse(JSON.stringify(statesList))
    tempStatesList = tempStatesList.map(val => {
      return {
        ...val,
        checked: userPreferredStatesTemp.includes(val.label) ? true : false
      }
    })
    setStatesList(tempStatesList)
    filterStatesListFunc('', tempStatesList)
  }

  const updateUserStatesListFunc = async () => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      let userEmail = manageAccountPageData?.userDetails?.emailId
      let data = {
        email: userEmail,
        newslettersStates: userPreferredStates
      }
      let response = await dispatch(updateUserStatesList(token, data));
      if (response.status === "SUCCESS") {
        // fetchUserStatesList(userEmail)
        fetchManageAccountPageData()
        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response.data?.message || response.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  }

  const handleChange = (event) => {
    if (event.target.name === "checkedAll" && event.target.checked) {
      setState({
        checkedAll: true,
        ORDER: true,
        BID_LOAD_RECEIVED: true,
        BUY_NOW: true,
        OFFER_LOAD_RECEIVED: true,
        OFFER_INVENTORY_RECEIVED: true,
        INVENTORY: true,
        LOAD: true,
        NETWORK: true,
      });
    } else if (event.target.name === "checkedAll" && !event.target.checked) {
      setState({
        checkedAll: false,
        ORDER: false,
        BID_LOAD_RECEIVED: false,
        BUY_NOW: false,
        OFFER_LOAD_RECEIVED: false,
        OFFER_INVENTORY_RECEIVED: false,
        INVENTORY: false,
        LOAD: false,
        NETWORK: false,
      });
    } else {
      for (let i = 0; i <= 2; i++) {
        if (i == 0) {
          setState((prevState) => {
            return {
              ...prevState,
              [event.target.name]: event.target.checked,
            };
          });
        } else {
          setState((prevState) => {
            if (
              prevState.BID_LOAD_RECEIVED &&
              prevState.BUY_NOW &&
              prevState.INVENTORY &&
              prevState.LOAD &&
              prevState.NETWORK &&
              prevState.OFFER_INVENTORY_RECEIVED &&
              prevState.OFFER_LOAD_RECEIVED &&
              prevState.ORDER
            ) {
              return {
                ...prevState,
                checkedAll: true,
              };
            } else {
              return {
                ...prevState,
                checkedAll: false,
              };
            }
          });
        }
      }
    }
  };

  const liveFields = (props, setFieldValue) => {
    return (
      <div className="w-100">
        <div className="my-2">
          <p>
            {pageLanguageContents?.Arrow_Preference[9]?.Time}
          </p>
        </div>
        {timmingHours(props, setFieldValue)}
      </div>
    );
  };

  const handleSubmit = async (props, officeHoursProps) => {
    const { submitForm, isValid, validateForm, setTouched } = props;
    submitForm().then(() => {
      if (isValid) {
        callSubmitApi(props, officeHoursProps);
        validateForm();
        setTouched({});
      }
    });
  };

  const handleSubmitNotification = async (props) => {
    let notificationArr = [];
    for (let i = 0; i < toggleNotification.length; i++) {
      if (
        toggleNotification[i] !== "checkedAll" &&
        state[toggleNotification[i]] === true
      ) {
        notificationArr.push(toggleNotification[i]);
      }
    }
    let data = {
      notificationPreferences: notificationArr,
    };

    let response = await dispatch(notificationPreferences(data, token));

    if (response.status === "SUCCESS") {
      let indexVal = null;
      if (pageLanguageContents?.Backend_Popups) {
        pageLanguageContents.Backend_Popups.forEach((val, index) => {
          if (Object.keys(val)[0] === response.message) {
            indexVal = index;
          }
        });
      }
      if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.message]);
      else setModalContent(response.message);
      setModalLink("");
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        let indexVal = null;
        if (pageLanguageContents?.Backend_Popups) {
          pageLanguageContents.Backend_Popups.forEach((val, index) => {
            if (Object.keys(val)[0] === response.message) {
              indexVal = index;
            }
          });
        }
        if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.message]);
        else setModalContent(response.message);
        setModalLink("");
        toggleModal();
      }
    }
  };
  const callSubmitApi = async (props, officeHoursProps) => {
    let data;
    let deliveryWindowBegin = props.values.deliveryWindowBegin;
    let deliveryWindowEnd = props.values.deliveryWindowEnd;
    let deliveryWindowBeginArr = props.values.deliveryWindowBegin.split(":");
    if (deliveryWindowBeginArr.length && deliveryWindowBeginArr[1]) {
      let setHours = deliveryWindowBeginArr[0];
      let setMinutes = deliveryWindowBeginArr[1];
      if (deliveryWindowBeginArr[0].length === 1) {
        setHours = 0 + deliveryWindowBeginArr[0];
      }
      if (deliveryWindowBeginArr[1].length === 1) {
        setMinutes = 0 + deliveryWindowBeginArr[1];
      }
      deliveryWindowBegin = setHours + ":" + setMinutes;
    }
    let deliveryWindowEndArr = props.values.deliveryWindowEnd.split(":");

    if (deliveryWindowEndArr.length && deliveryWindowEndArr[1]) {
      let setHours = deliveryWindowEndArr[0];
      let setMinutes = deliveryWindowEndArr[1];
      if (deliveryWindowEndArr[0].length === 1) {
        setHours = 0 + deliveryWindowEndArr[0];
      }
      if (deliveryWindowEndArr[1].length === 1) {
        setMinutes = 0 + deliveryWindowEndArr[1];
      }
      deliveryWindowEnd = setHours + ":" + setMinutes;
    }
    if (deliveryWindowBegin === "00:00" || deliveryWindowEnd === "00:00") {
      setModalContent("Preference window time is invalid.");
      setModalLink("");
      toggleModal();
      return
    }

    const fromTimeValue = parseInt(deliveryWindowBegin?.replace(":", ""));
    const toTimeValue = parseInt(deliveryWindowEnd?.replace(":", ""));
    if ((accountType === "Buyer" || accountType === "Both") && toTimeValue <= fromTimeValue) {
      setModalContent("Preference window time is invalid.");
      setModalLink("");
      toggleModal();
      return
    }

    let notificationArr = [];
    for (let i = 0; i < toggleNotification.length; i++) {
      if (
        toggleNotification[i] !== "checkedAll" &&
        state[toggleNotification[i]] === true
      ) {
        notificationArr.push(toggleNotification[i]);
      }
    }

    let milesValSet = "";
    if (officeHoursProps.milesVal) {
      milesValSet = officeHoursProps.milesVal;
    }

    data = {
      dayOfWeeks: officeHoursProps.dayOfWeeks,
      miles: milesValSet,
      officeHourStart: officeHoursProps.officeHourStart,
      officeHourEnd: officeHoursProps.officeHourEnd,
    }
    if (accountType === "Buyer" || accountType === "Both") {
      data.deliveryWindowBegin = deliveryWindowBegin
      data.deliveryWindowEnd = deliveryWindowEnd
    }
    if (props.values.vehiclePreferences !== "" && props.values.dropLive !== "") {
      data.vehiclePreferences = [props.values.vehiclePreferences];
      data.dropLive = props.values.dropLive;
    }

    // if (accountType === "Buyer" || accountType === "Both") {
    //   data = {
    //     deliveryWindowBegin: deliveryWindowBegin,
    //     deliveryWindowEnd: deliveryWindowEnd,
    //     notificationPreferences: notificationArr,
    //     miles: milesValSet,
    //   };


    // } else {
    //   let isDeliveryAvailable = "";
    //   if (props.values.isDeliveryAvailable === "true") {
    //     isDeliveryAvailable = true;
    //   } else {
    //     isDeliveryAvailable = false;
    //   }
    //   if (milesValSet) {
    //     data = {
    //       isDeliveryAvailable: isDeliveryAvailable,
    //       distanceWillingToTravel: props.values.distanceWillingToTravel,
    //       unitsDistanceTravel: "MILES",
    //       deliveryTime: parseInt(props.values.deliveryTime),
    //       deliveryTimeUnits: "HOURS",
    //       officeHourStart: deliveryWindowBegin,
    //       officeHourEnd: deliveryWindowEnd,
    //       notificationPreferences: notificationArr,
    //       miles: milesValSet,
    //     };
    //   } else {
    //     data = {
    //       isDeliveryAvailable: isDeliveryAvailable,
    //       distanceWillingToTravel: props.values.distanceWillingToTravel,
    //       unitsDistanceTravel: "MILES",
    //       deliveryTime: parseInt(props.values.deliveryTime),
    //       deliveryTimeUnits: "HOURS",
    //       officeHourStart: deliveryWindowBegin,
    //       officeHourEnd: deliveryWindowEnd,
    //       notificationPreferences: notificationArr,
    //       miles: milesValSet,
    //     };
    //   }
    // }

    let response = "";
    response = await dispatch(manageAccCompanyPrefUpdate(data, token));

    // if (accountType !== "Seller") {
    //   response = await dispatch(buyerPostLoadProfilePost(data, token));
    // } else {
    //   response = await dispatch(buyerPostInentoryProfilePost(data, token));
    // }
    if (response.status === "SUCCESS") {
      setUpdateButtonDisableState(false)
      localStorage.setItem("miles", milesValSet);
      setModalContent("Updated successfully.");
      setModalLink("");
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        setModalContent(response.message || 'Something went wrong, please try again.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const timmingHours = (props, setFieldValue) => {
    return (
      <DateTimeWrapper className={`${styles.dateAndTime} row`}>
        <div className="col-md-4 col-5">
          <TimePickerInput
            name="deliveryWindowBegin"
            type="time"
            // prePopulateState={response}
            selectedValue={props.values?.deliveryWindowBegin}
            disabled={!updateButtonDisableState}
            showErrorMessages={true}
            onChangeHandler={(time) => {
              if (time === "00:00") {
                setFieldValue("deliveryWindowBegin", "")
              }
            }}
          />
        </div>
        <span className={styles.toStyle}>To</span>
        <div className="col-md-4 col-5">
          <TimePickerInput
            name="deliveryWindowEnd"
            type="time"
            // prePopulateState={response}
            selectedValue={props.values?.deliveryWindowEnd}
            disabled={!updateButtonDisableState}
            showErrorMessages={true}
            onChangeHandler={(time) => {
              if (time === "00:00") {
                setFieldValue("deliveryWindowBegin", "")
              }
            }}
          />
        </div>
      </DateTimeWrapper>
    );
  };

  const [tooltipPreference, setTooltipPreference] = useState(false);
  const iIcon = (infoTxt) => {
    return (
      <>
        <img
          id="TooltipPreference"
          src={information}
          style={{
            paddingLeft: "5px",
            position: "relative",
            top: "-1px",
          }}
        />
        <Tooltip
          placement="right"
          isOpen={tooltipPreference}
          target="TooltipPreference"
          toggle={() => setTooltipPreference(!tooltipPreference)}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };

  const [emailNotificationTooltip, setEmailNotificationTooltip] = useState(false);
  const [emailNotificationTooltipSection, setEmailNotificationTooltipSection] = useState("");
  const iIconEmailNotification = (infoSection, infoTxt) => {
    return (
      <>
        <img
          id={infoSection}
          src={information}
          style={{
            position: "relative",
            top: "-1px",
            marginLeft: "6px",
          }}
        />
        <Tooltip
          placement="right"
          isOpen={
            emailNotificationTooltip &&
            emailNotificationTooltipSection === infoSection
          }
          target={infoSection}
          toggle={() => {
            setEmailNotificationTooltip(!emailNotificationTooltip);
            setEmailNotificationTooltipSection(
              emailNotificationTooltipSection === "" ? infoSection : ""
            );
          }}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };
  const storedData = useSelector((state) => state.storedData.payload);
  let disableFlg = storedData?.guestUser

  const [tooltipOpenEmail, setTooltipOpenEmail] = useState(false);
  const iIconEmailNotifications = (infoTxt) => {
    return (
      <>
        <img
          id="TooltipOpenEmail"
          src={information}
          style={{
            paddingLeft: "5px",
            position: "relative",
            top: "-1px",
          }}
        />
        <Tooltip
          placement="right"
          isOpen={tooltipOpenEmail}
          target="TooltipOpenEmail"
          toggle={() => setTooltipOpenEmail(!tooltipOpenEmail)}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };
  return (
    <>
      <Helmet title="Manage Account: Control Your Profile Information| PalletTrader" >
        <meta name="description"
          content="Take control of your marketplace account. Easily manage your profile, settings, and preferences for a personalized and seamless buying and selling experience." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/manage-account" />
      </Helmet>
      <Layout selectedSearch={selectedSearch} topBarViewMobile={"hide"} pageType={'ManageAccount'}>
        <Profile pageData={manageAccountPageData} />
        <PaymentDetail pageData={manageAccountPageData} fetchManageAccountPageData={fetchManageAccountPageData} scrollToProfileSection={scrollToProfileSection} />

        {!disableFlg && manageAccountPageData && (
          <Formik
            initialValues={getInitialValues(manageAccountPageData)}
            validationSchema={VALIDATION_SCHEMA}
            onSubmit={(values) => { }}
          >
            {(props) => {
              const { isValid, dirty, values, errors, touched, setFieldValue } =
                props;

              return (
                <>
                  <Form className={styles.internalPreferences}>
                    <Container>
                      <Wrapper>
                        <div className="blank-div"></div>
                        <div className="section-wrapper">
                          <div style={{ position: "relative" }}>
                            <div class="community-details-header seller">
                              <div class="community-name">
                                <h4>{pageLanguageContents?.Arrow_Preference[0]?.MainTitle}{iIcon(pageLanguageContents?.Arrow_Preference[19]?.PreferencesQues)}</h4>
                              </div>
                            </div>
                            {manageAccountPageData?.userDetails?.userRole !== 'SELLER' && (
                              <BuyerSettings>
                                <h3 className="my-2">
                                  {pageLanguageContents?.Arrow_Preference[1]?.Title}
                                </h3>
                                <div className="row mx-0">
                                  <div className="col-12 p-0">
                                    <div className="my-2">
                                      <p>
                                        {pageLanguageContents?.Arrow_Preference[2]?.Equipment}
                                      </p>
                                    </div>

                                    <div className="row">
                                      {notesArr &&
                                        notesArr.map((value, index) => (
                                          <div
                                            className="col-md-4 col-sm-12"
                                            key={index}
                                          >
                                            <Field
                                              component={RadioButton}
                                              name="vehiclePreferences"
                                              id={value.value}
                                              defaultValue={notesArr[0].value}
                                              disabled={!updateButtonDisableState}
                                              onSelect={(e) => { }}
                                              label={value.label}
                                            />
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                </div>

                                <div className="row mx-0">
                                  <div className="col-md-12 col-sm-12 p-0">
                                    {(props.values?.vehiclePreferences && props.values?.vehiclePreferences !== '') &&
                                      <>
                                        <div className="my-2">
                                          <p>{pageLanguageContents?.Arrow_Preference[6]?.Mode}</p>
                                        </div>
                                        <div className="row">
                                          {dropLiveState?.map((value, index) => (
                                            <div className="col-md-4" key={index}>
                                              <Field
                                                component={RadioButton}
                                                name="dropLive"
                                                id={value.value}
                                                defaultValue={dropLiveState[0].value}
                                                disabled={!updateButtonDisableState}
                                                onSelect={(e) => { }}
                                                label={value.label}
                                              // required // Add the required attribute
                                              />
                                            </div>
                                          ))}
                                        </div>
                                        {props.errors.dropLive && props.touched.dropLive && (
                                          <div className="text-danger">{props.errors.dropLive}</div>
                                        )}
                                      </>
                                    }
                                  </div>
                                  <div className="col-md-12 col-sm-12 p-0">
                                    {liveFields(props, setFieldValue)}
                                  </div>
                                </div>
                              </BuyerSettings>
                            )}

                            <OfficeHours
                              pageData={manageAccountPageData}
                              updateButtonDisableState={updateButtonDisableState}
                              updateButtonDisableStateToggle={val => setUpdateButtonDisableState(val)}
                              callBackFun={(officeHoursProps) => {
                                handleSubmit(props, officeHoursProps);
                              }}
                            />
                          </div>

                          <Notification>
                            {(manageAccountPageData?.userDetails?.userRole !== 'GUEST' && manageAccountPageData?.userDetails?.userRole !== 'BUYER') &&
                              <h3 className="my-2 mt-4">Sellers: Set Your Service Area  </h3>
                            }
                            {(manageAccountPageData?.userDetails?.userRole !== 'GUEST' && manageAccountPageData?.userDetails?.userRole !== 'BUYER') &&
                              <LocationPrefWrapper>
                                <p>{manageAccountPageData?.userDetails?.userRole === 'BROKER' ?
                                  'Which states do you service? PalletTrader will send you notifications of opportunities in your preferred areas.' :
                                  'Please add which states you service below. PalletTrader will send you opportunities in your target areas.'}</p>
                                <input placeholder="Please select the required states..." className="stateSelectInput" value={stateSearch}
                                  onClick={() => {
                                    setDisplayStatesList(true)
                                    setUserPreferredStatesTemp(userPreferredStates)
                                  }}
                                  onChange={e => filterStatesListFunc(e.target.value)} />
                                {displayStatesList && <div className="statesListDiv">
                                  <div className="statesListInnerDiv">
                                    <label className='checkbox-container' style={{ margin: '10px' }}>
                                      <input
                                        id={'ALL'}
                                        name={'ALL'}
                                        type='checkbox'
                                        checked={stateAllChecked}
                                        disabled={false}
                                        onClick={(event) => {
                                          onCheckStateBox('ALL', event.target.checked)
                                          setStateAllChecked(event.target.checked)
                                        }}
                                      />
                                      <span className='checkMark'></span>
                                      ALL
                                    </label>
                                    {filteredStatesList?.length === 0 && <p style={{ textAlign: 'center' }}>No matches found.</p>}
                                    {filteredStatesList?.map(item => {
                                      return (
                                        <label className='checkbox-container' style={{ margin: '10px' }}>
                                          <input
                                            id={item.label}
                                            name={item.label}
                                            type='checkbox'
                                            checked={item.checked}
                                            disabled={false}
                                            onClick={(event) => {
                                              onCheckStateBox(item.label, event.target.checked)
                                            }}
                                          />
                                          <span className='checkMark'></span>
                                          {item.value}-{item.label}
                                        </label>
                                      )
                                    })}
                                  </div>
                                  <div style={{ display: 'flex', justifyContent: 'end' }}>
                                    <Button
                                      type="app-green-button"
                                      handleClick={() => {
                                        setDisplayStatesList(false)
                                        filterStatesListFunc('')
                                      }}
                                    >
                                      Add
                                    </Button>
                                    <Button
                                      type="app-green-button"
                                      handleClick={() => {
                                        cancelStatesListDropDown()
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                  </div>
                                </div>}
                                {!displayStatesList && <div className="selectedStatesListDiv">
                                  {userPreferredStates && userPreferredStates.map(item => {
                                    return (
                                      <h6>{stateConvert(item)}<span onClick={() => deleteNewsletterState(item)}>x</span></h6>
                                    )
                                  })}
                                </div>}
                                <div className={styles.footer}>
                                  <Button
                                    disabled={displayStatesList}
                                    type="app-green-button"
                                    handleClick={updateUserStatesListFunc}
                                  >Submit
                                  </Button>
                                </div>
                              </LocationPrefWrapper>
                            }

                            <h3 className="my-2 mt-4">
                              {pageLanguageContents?.Notification[0]?.Title}
                              {iIconEmailNotifications(pageLanguageContents?.Notification[12]?.EmailPopUp)}
                            </h3>
                            <p>Use the toggles below to customize your email settings.</p>

                            <FormControlLabel
                              control={
                                <Switch
                                  checked={state.checkedAll}
                                  onChange={handleChange}
                                  name="checkedAll"
                                />
                              }
                              label={pageLanguageContents?.Notification[1]?.ToggleB_OP1}
                            />
                            <OtherNotification>
                              <div>
                                <FormControlLabel
                                  style={{ pointerEvents: "none" }}
                                  control={
                                    <Switch
                                      checked={state.LOAD}
                                      onChange={handleChange}
                                      style={{ pointerEvents: "auto" }}
                                      name="LOAD"
                                    />
                                  }
                                  label={
                                    <>
                                      {pageLanguageContents?.Notification[5]?.ToggleB_OP5}
                                      <span style={{ pointerEvents: "auto" }}>{iIconEmailNotification(
                                        "palletNeededPostConfirmation",
                                        "[Title]=Content Required"
                                      )}</span>
                                    </>
                                  }
                                />

                              </div>

                              <div>
                                <FormControlLabel
                                  style={{ pointerEvents: "none" }}
                                  control={
                                    <Switch
                                      checked={state.INVENTORY}
                                      onChange={handleChange}
                                      style={{ pointerEvents: "auto" }}
                                      name="INVENTORY"
                                    />
                                  }
                                  label={
                                    <>
                                      {pageLanguageContents?.Notification[8]?.ToggleB_OP8}
                                      <span style={{ pointerEvents: "auto" }}>
                                        {iIconEmailNotification(
                                          "palletInventoryPostConfirmation",
                                          "[Title]=Content Required"
                                        )}
                                      </span>
                                    </>
                                  }
                                />

                              </div>

                              <div>
                                <FormControlLabel
                                  style={{ pointerEvents: "none" }}
                                  control={
                                    <Switch
                                      checked={state.BID_LOAD_RECEIVED}
                                      onChange={handleChange}
                                      style={{ pointerEvents: "auto" }}
                                      name="BID_LOAD_RECEIVED"
                                    />
                                  }
                                  label={
                                    <>
                                      {pageLanguageContents?.Notification[6]?.ToggleB_OP6}
                                      <span style={{ pointerEvents: "auto" }}>
                                        {iIconEmailNotification(
                                          "palletNeededPostBidReceived",
                                          "[Title]=Content Required"
                                        )}
                                      </span>
                                    </>
                                  }
                                />

                              </div>

                              <div>
                                <FormControlLabel
                                  style={{ pointerEvents: "none" }}
                                  control={
                                    <Switch
                                      checked={state.OFFER_INVENTORY_RECEIVED}
                                      onChange={handleChange}
                                      style={{ pointerEvents: "auto" }}
                                      name="OFFER_INVENTORY_RECEIVED"
                                    />
                                  }
                                  label={
                                    <>
                                      {pageLanguageContents?.Notification[4]?.ToggleB_OP4}
                                      <span style={{ pointerEvents: "auto" }}>
                                        {iIconEmailNotification(
                                          "inventoryPostOfferReceived",
                                          "[Title]=Content Required"
                                        )}
                                      </span>
                                    </>
                                  }
                                />

                              </div>

                              <div>
                                <FormControlLabel
                                  style={{ pointerEvents: "none" }}
                                  control={
                                    <Switch
                                      checked={state.BUY_NOW}
                                      style={{ pointerEvents: "auto" }}
                                      onChange={handleChange}
                                      name="BUY_NOW"
                                    />
                                  }
                                  label={
                                    <>
                                      {pageLanguageContents?.Notification[3]?.ToggleB_OP3}
                                      <span style={{ pointerEvents: "auto" }}>
                                        {iIconEmailNotification(
                                          "inventoryPostBuyNowOffer",
                                          "[Title]=Content Required"
                                        )}
                                      </span>
                                    </>
                                  }
                                />

                              </div>

                              <div>
                                <FormControlLabel
                                  style={{ pointerEvents: "none" }}
                                  control={
                                    <Switch
                                      checked={state.OFFER_LOAD_RECEIVED}
                                      style={{ pointerEvents: "auto" }}
                                      onChange={handleChange}
                                      name="OFFER_LOAD_RECEIVED"
                                    />
                                  }
                                  label={
                                    <>
                                      {pageLanguageContents?.Notification[7]?.ToggleB_OP7}
                                      <span style={{ pointerEvents: "auto" }}>
                                        {iIconEmailNotification(
                                          "palletReceivedOffer",
                                          "[Title]=Content Required"
                                        )}
                                      </span>
                                    </>
                                  }
                                />

                              </div>

                              <div>
                                <FormControlLabel
                                  style={{ pointerEvents: "none" }}
                                  control={
                                    <Switch
                                      checked={state.ORDER}
                                      style={{ pointerEvents: "auto" }}
                                      onChange={handleChange}
                                      name="ORDER"
                                    />
                                  }
                                  label={
                                    <>
                                      {pageLanguageContents?.Notification[2]?.ToggleB_OP2}
                                      <span style={{ pointerEvents: "auto" }}>
                                        {iIconEmailNotification(
                                          "orderConfirmation",
                                          "[Title]=Content Required"
                                        )}
                                      </span>
                                    </>
                                  }
                                />

                              </div>

                              <div>
                                <FormControlLabel
                                  style={{ pointerEvents: "none" }}
                                  control={
                                    <Switch
                                      checked={state.NETWORK}
                                      style={{ pointerEvents: "auto" }}
                                      onChange={handleChange}
                                      name="NETWORK"
                                    />
                                  }
                                  label={
                                    <>
                                      {pageLanguageContents?.Notification[9]?.ToggleB_OP9}
                                      <span style={{ pointerEvents: "auto" }}>
                                        {iIconEmailNotification(
                                          "myCommunity",
                                          pageLanguageContents?.Notification[13]?.MyCommunityPopUp
                                        )}
                                      </span>
                                    </>
                                  }
                                />
                              </div>
                            </OtherNotification>
                          </Notification>

                          <div className={styles.footer}>
                            <Button
                              type="app-green-button"
                              handleClick={() => {
                                handleSubmitNotification(props);
                              }}
                            >
                              {pageLanguageContents?.Notification[10]?.Button_2}
                            </Button>
                          </div>

                          <UserTaxExemptionForm
                            pageData={manageAccountPageData}
                            updateButtonDisableState={updateButtonDisableState}
                            updateButtonDisableStateToggle={val => setUpdateButtonDisableState(val)}
                            callBackFun={(officeHoursProps) => {
                              handleSubmit(props, officeHoursProps);
                            }}
                          />
                        </div>
                      </Wrapper>
                    </Container>
                  </Form>
                  <YesNoModal
                    isOpen={yesNomodal}
                    toggle={yesNoToggleModal}
                    title=""
                    onClickHander={(val) => {
                      if (val === "no") {
                        setFieldValue("appointment", "DELIVERY");
                      }
                    }}
                    content={pageLanguageContents?.Notification[11]?.AlertContent1}
                    link="/"
                  />
                </>
              );
            }}
          </Formik>
        )}

        {/* {((accountType === 'Guest') && (disableFlg)) && <> 
        <UpgradeGuestSubscription />
        <PaymentDetail pageData={manageAccountPageData} fetchManageAccountPageData={fetchManageAccountPageData} />
        </>} */}

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={title}
          content={modalContent}
          link={modalLink}
        />
      </Layout>
    </>
  );
};

export default ManageAccount;

const Wrapper = styled.div`
  margin: 20px auto;
  display: flex;
  /* grid-template-columns: 237px 1fr; */
  grid-column-gap: 46px;
  > div {
    flex: 1;
  }
  .blank-div {
    max-width: 237px;
  }
  .section-wrapper {
    border-radius: 10px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.16);
    padding: 15px 28px;
  }

  @media (max-width: 1250px) {
    display: unset;
    .blank-div {
      display: none;
    }
  }
`;

const Container = styled.div`
  max-width: 1407px;
  margin: 0 auto;
  padding: 0px 10px;
  @media (max-width: 1250px) {
    padding: 15px;
  }
`;
const HeadingSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
  > div {
    width: 19px;
    height: 4px;
    border-radius: 2.8px;
    background-color: #00b3ff;
    margin: 0 8px;
  }
  h3 {
    color: #00b3ff;
    font-size: 22px;
  }
`;
const BuyerSettings = styled.div`
  h3 {
    font-family: "latobold";
    font-size: 22px;
  }

  margin-bottom: 25px;
  & .field {
    margin-bottom: 0;
  }
  @media (max-width: 650px) {
    h3 {
      font-size: 22px;
    }
  }
`;
const SellerSettings = styled.div`
  margin-bottom: 25px;
  & .field {
    margin-bottom: 0;
  }
`;

const Notification = styled.div`
  border-top: solid 1px #87cdf1;
  margin: 35px 0;
  padding-top: 15px;
  h3 {
    font-family: "latobold";
    font-size: 22px;
  }
  label {
    color: #212551;
  }

  .MuiSwitch-thumb {
    background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
  }
  .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
    background-color: #b7b4b2 !important;
  }
  .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background-color: #61ae24 !important;
  }
  @media (max-width: 650px) {
    h3 {
      font-size: 20px;
    }
  }
`;

const LocationPrefWrapper = styled.div`
margin : 15px 0 15px 0;
.stateSelectInput{
  height: 37px;
  border-radius: 5px;
  border: solid 1px #87cdf1;
  width: 274px;
  padding: 7px;
}
.statesListDiv{
  height: 321px;
  width: 274px;
  border-radius: 5px;
  border: solid 1px #87cdf1;
  margin-top: 5px; 
  .button {
    margin: 4px;
  }
}
.statesListInnerDiv{   
  overflow: auto;
  height: 275px;
}
.selectedStatesListDiv{
  margin-top:10px;
  display: flex;
  flex-wrap: wrap;
  h6{
    border: 1px solid green;
    border-radius: 13px;
    padding: 3px;
    margin:5px;
    font-size: 12px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-left: 10px;
    span{
      font-size: 15px;
      padding: 0px 4px 3px 5px;
      cursor: pointer;
    }
  }
}
`

const OtherNotification = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  .stateSelectInput{
    height: 37px;
    border-radius: 5px;
    border: solid 1px #87cdf1;
    width: 274px;
    padding: 7px;
  }
  .statesListDiv{
    height: 321px;
    width: 274px;
    border-radius: 5px;
    border: solid 1px #87cdf1;
    margin-top: 5px; 
    .button {
      position: relative;
      left: 221px;
    }
  }
  .statesListInnerDiv{   
    overflow: auto;
    height: 275px;
  }
  .selectedStatesListDiv{
    margin-top:10px;
    span{
      border: 1px solid green;
      border-radius: 13px;
      padding: 3px;
      background: #ecf5ec;
      margin:5px;
    }
  }
  @media (max-width: 625px) {
    grid-template-columns: 1fr;
  }
`;

const DateTimeWrapper = styled.div`
  .custom-date-piker {
    display: block;
    .app-input-text {
      margin-bottom: 0;
    }
  }
`;
